"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixNestedCancelCommands = fixNestedCancelCommands;
// fixNestedCancelCommands ensures that all commands and variables nested
// inside of a \cancel command are braced/curly bracketed.
// This syntax is required by MathJax in order to render, but not by KaTeX.
// For example, \cancel\text a^2 is valid in KaTeX, but not MathJax.
function fixNestedCancelCommands(tex) {
    // Fractions have a very unique syntax in MathJax, so we need
    // to match them seperately in order to brace them properly.
    // For example, it changes \cancel\dfrac{a}{b} to \cancel{\dfrac{a}{b}}
    const cancelNodeWithFractions = /\\cancel\s*(\\dfrac[{]+[^{}]+}+{[^{}]+}+)/g;
    tex = tex.replace(cancelNodeWithFractions, "\\cancel{$1}");
    // There are some fractions in our content where the numerator contains
    // extra braces, e.g. \dfrac{{1}}{2}. This regex puts braces around those
    // fractions.
    const cancelNodeWithFractionsWithExtraBraces = /\\cancel\s*(\\dfrac{[^{}]*{[^{}]+}[^{}]*}{[^{}]+})/g;
    tex = tex.replace(cancelNodeWithFractionsWithExtraBraces, "\\cancel{$1}");
    // Find and brace all subcommands with a one-character argument
    // For example, it matches \cancel\blueE2 or \cancel \blueE A
    const cancelNodeWithSubCommandWithOneCharArg = /\\cancel\s*(\\blue[A-Z]|\\text)(\s+\w|\s*\d)/g;
    tex = tex.replace(cancelNodeWithSubCommandWithOneCharArg, (_, subcommand, arg) => `\\cancel{${subcommand}{${arg.trim()}}}`);
    // Add braces around subcommands that already their arguments
    // properly braced. For example, it changes \cancel\blueE{6} to \cancel{\blueE{6}}
    const cancelNodeEncapsulateSubCommands = /\\cancel\s*((?:\\text|\\blue[A-Z]|\\gold[A-Z])[{]+[^}]+[}])/g;
    tex = tex.replace(cancelNodeEncapsulateSubCommands, "\\cancel{$1}");
    // Convert all \cancel\leq commands to \nleq commands
    const cancelNodeLeq = /(\\cancel(?:\s*\\leq|\s*{\s*\\leq\s*}))/g;
    tex = tex.replace(cancelNodeLeq, "\\nleq ");
    // Convert all \cancel\geq commands to \ngeq commands
    const cancelNodeGeq = /(\\cancel(?:\s*\\geq|\s*{\s*\\geq\s*}))/g;
    tex = tex.replace(cancelNodeGeq, "\\ngeq ");
    // Convert all \cancel\gt commands to \ngtr commands
    const cancelNodeGt = /(\\cancel(?:\s*\\gt|\s*{\s*\\gt\s*}))/g;
    tex = tex.replace(cancelNodeGt, "\\ngtr ");
    // Convert all \cancel> commands to \ngtr commands
    const cancelNodeGreaterThan = /(\\cancel(?:\s*>|\s*{\s*>\s*}))/g;
    tex = tex.replace(cancelNodeGreaterThan, "\\ngtr ");
    // Convert all \cancel\lt commands to \ngtr commands
    const cancelNodeLt = /(\\cancel(?:\s*\\lt|\s*{\s*\\lt\s*}))/g;
    tex = tex.replace(cancelNodeLt, "\\nless ");
    // Convert all \cancel< commands to \ngtr commands
    const cancelNodeLessThan = /(\\cancel(?:\s*<|\s*{\s*<\s*}))/g;
    tex = tex.replace(cancelNodeLessThan, "\\nless ");
    // Convert all \cancel= commands to \ngtr commands
    const cancelNodeEqual = /(\\cancel(?:\s*=|\s*{\s*=\s*}))/g;
    tex = tex.replace(cancelNodeEqual, "\\neq ");
    return tex;
}
